import { createSlice } from "@reduxjs/toolkit";

const initialState = { id: null, sourceLink: null, elements: null };

// eslint-disable-next-line import/prefer-default-export
export const informationSidepanel = createSlice({
  name: "informationSidepanel",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setInformationSidepanel: (state, action) => {
      state.id = action.payload.id;
      state.sourceLink = action.payload.sourceLink;
      state.elements = action.payload.elements;
      state.content = action.payload.content;
    },

    closeInformationSidepanel: () => initialState,
  },
});

export const { setInformationSidepanel, closeInformationSidepanel } =
  informationSidepanel.actions;

export default informationSidepanel.reducer;

export const selectInformationSidepanel = (state) => state.informationSidepanel;
